











import { Component, Prop, Vue } from 'vue-property-decorator';
import appConfig from '../../appConfig';

@Component
export default class Error extends Vue {
    get faqUrl(): string {
        return appConfig.faqPageUrl;
    }
}
